module.exports = __webpack_public_path__ + "GnuMICR.5e0faee129a248e16878.otf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/GnuMICR.otf
// module id = ../../../../../src/fonts/GnuMICR.otf
// module chunks = styles